import { Component, OnInit }  from '@angular/core';
import { BlockUI, NgBlockUI } from 'ng-block-ui';
import { NgModel }            from '@angular/forms';
import { TranslateService }   from '@ngx-translate/core';
import { UIRouter }           from '@uirouter/core';

import { EmailVerificationService } from './email-verification.service';
import { MessagesService }          from '../messages/messages.service';
import { TextControlComponent }     from '../shared/controls/text-control/text-control.component';

@Component({
  selector   : 'wor-email-verification',
  styles: [ require('./email-verification.component.scss') ],
  template: require('./email-verification.component.html')
})
export class EmailVerificationComponent extends TextControlComponent implements OnInit {
  @BlockUI('emailVerificationBlock') block : NgBlockUI;

  originalDomain: string;

  constructor (
    public emailVerificationService : EmailVerificationService,
    private messagesService         : MessagesService,
    private router                  : UIRouter,
    public  translateService        : TranslateService
  ) {


    super();


  }

  ngOnInit () : void {


    this.originalDomain = this.emailVerificationService.getDomainFromEmail(this._model);


  }

  getEmailLabel ( email : NgModel ) : string {
    let status : string;

    if ( email.dirty && email.invalid ) {


      return this.translateService.instant('GENERAL_SPACE.ERROR_MESSAGE.INVALID_EMAIL');


    }

    if ( this.emailVerificationService.isDomainStatus('notAttempted') || this.emailVerificationService.isDomainStatus('unverified') ) {
      status = this.translateService.instant('JS_SPACE.EMAIL.DOMAIN_UNVERIFIED');
    }

    else if ( this.emailVerificationService.isDomainStatus('pending') ) {
      status = this.translateService.instant('JS_SPACE.EMAIL.DOMAIN_PENDING');
    }

    else if ( this.emailVerificationService.isDomainStatus('verified') ) {
      status = this.translateService.instant('JS_SPACE.EMAIL.DOMAIN_VERIFIED');
    }

    const label = this.label || this.translateService.instant('GENERAL_SPACE.FIELD.EMAIL');

    return status
      ? `${ label } (${ status })`
      : label;
  }

  hasDomainChanged () : boolean {


    const currentDomain = this.emailVerificationService.getDomainFromEmail(this._model);

    return !(
      currentDomain
      && this.originalDomain
      && currentDomain === this.originalDomain
    );


  }

  verifyDomain () : void {
    if ( this.hasDomainChanged() ) {
      this.messagesService.show(this.translateService.instant('JS_SPACE.EMAIL.SAVE_BEFORE_VERIFY'),'warning');

      return;
    }

    this.block.start();

    this.emailVerificationService.verifyDomain()
    .then(() => this.messagesService.show(this.translateService.instant('JS_SPACE.EMAIL.DOMAIN_VERIFICATION_SENT'), 'success'))
    .catch(error => this.messagesService.error(error))
    .finally(() => {
      this.block.stop();

      this.router.stateService.reload();
    });
  }
}
